import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const Img = styled(ImageLibpixel)`
  width: 200px;
  height: 100px;
  object-fit: contain;
  transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  @media (max-width: 1024px) {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  @media (min-width: 1025px) {
    &:hover img {
      transform: scale(1.2);
    }
  }
  @media (max-width: 1024px) {
    transform: none;
    width: 200px;
  }
  @media (max-width: 415px) {
    width: 160px;
  }
`;

const ClientCard = ({ logoUrl }) => {
  return (
    <Container>
      <ImgWrapper>
        <Img src={logoUrl} alt={_("kunde logo")} />
      </ImgWrapper>
    </Container>
  );
};

ClientCard.propTypes = {
  logoUrl: PropTypes.string.isRequired,
};

export default ClientCard;
